import React from 'react';
import PropTypes from 'prop-types';

const SharePath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M17 5.647v3.934c-9.399.062-17 7.741-17 17.203v1.517a.75.75 0 0 0 1.464.228C4.112 22.536 10.067 18.347 17 18.301v3.992c0 1.031.766 1.439 1.709.89l12.557-8.115c.939-.546.985-1.498.091-2.122L18.619 4.893c-.302-.212-.586-.313-.829-.313-.472 0-.79.381-.79 1.067z"
    />
  );
};

SharePath.propTypes = {
  fill: PropTypes.string,
};

export default SharePath;



// WEBPACK FOOTER //
// ./src/icon/svgs/interaction/share.jsx